@if (ConnGroupList) {
  @if (useIconButton) {
    <forge-icon-button (click)="onClick($event)">
      <forge-icon name="vector_link"></forge-icon>
      <forge-tooltip placement="bottom">
        {{ConnGroup}} - {{Department}}
      </forge-tooltip>
    </forge-icon-button>
  } @else {
    <forge-button (click)="onClick($event)" id="conn-group">
      <div fxLayoutAlign="space-between center">
        <div fxLayout="column" fxLayoutAlign="center start">
          <div class="forge-typography--body1">{{ConnGroup}}</div>
          @if (showDepartment) {
            <div class="forge-typography--label1">{{Department}}</div>
          }
        </div>
        <forge-open-icon [open]="popupOpen">
        </forge-open-icon>
      </div>
      <forge-ripple></forge-ripple>
    </forge-button>
    @if (!showDepartment) {
      <forge-tooltip anchor="conn-group" placement="bottom">
        {{ConnGroup}} - {{Department}}
      </forge-tooltip>
    }
  }
}

